// extracted by mini-css-extract-plugin
export default {"title":"TitleText_title__6hzGx","title2":"TitleText_title2__J-GPs"};